import axiosInstance from '../../axiosInstance';
import type { Profile, UpdateProfileRequest } from './types';

/**
 * Get current user profile
 * Returns the profile of the authenticated customer. If profile doesn't exist, it will be auto-created.
 */
export const getCurrentProfile = async (): Promise<Profile> => {
  console.log('[ProfileService] 🔍 Fetching profile from /user/profile/me');
  console.log('[ProfileService] Current cookies:', document.cookie);
  console.log('[ProfileService] Request will be made to:', axiosInstance.defaults.baseURL + '/user/profile/me');
  
  try {
    const { data } = await axiosInstance.get('/user/profile/me');
    console.log('[ProfileService] ✅ Profile response received:', data);
    
    if (!data.profile) {
      console.warn('[ProfileService] ⚠️ Profile is NULL - user may not be authenticated!', {
        responseData: data,
        cookies: document.cookie,
      });
    }
    
    return data.profile;
  } catch (error: any) {
    console.error('[ProfileService] ❌ Profile fetch error:', {
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      data: error?.response?.data,
      config: {
        url: error?.config?.url,
        method: error?.config?.method,
        baseURL: error?.config?.baseURL,
        headers: error?.config?.headers,
      },
      cookies: document.cookie,
    });
    throw error;
  }
};

/**
 * Update current user profile
 * Updates the authenticated customer's profile. Supports updating name, cpf, phone, and profile picture.
 */
export const updateProfile = async (
  profileData: UpdateProfileRequest
): Promise<Profile> => {
  const formData = new FormData();

  if (profileData.name !== undefined) {
    formData.append('name', profileData.name);
  }
  if (profileData.cpf !== undefined) {
    formData.append('cpf', profileData.cpf);
  }
  if (profileData.phone !== undefined) {
    formData.append('phone', profileData.phone);
  }
  if (profileData.profilePic) {
    formData.append('profilePic', profileData.profilePic);
  }

  const { data } = await axiosInstance.patch<Profile>(
    '/user/profile/',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return data;
};
